var log = {
  exports: {}
};

export { log as l };
//# sourceMappingURL=log.js.map
